import { ChainId, ERC20Token } from '@pancakeswap/sdk'

export const CAKE_MAINNET = new ERC20Token(
  ChainId.BSC,
  '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
  18,
  'CAKE',
  'PancakeSwap Token',
  'https://pancakeswap.finance/',
)

// export const POT_TESTNET = new ERC20Token(
//   ChainId.X1_TESTNET,
//   '0x0c58f92b53E8a683feB97e8485b1D73fE3190F58',
//   18,
//   'POT',
//   'PotatoSwap Token',
//   'https://pancakeswap.finance/',
// )

export const CAKE_TESTNET = new ERC20Token(
  ChainId.BSC_TESTNET,
  '0xFa60D973F7642B748046464e165A65B7323b0DEE',
  18,
  'CAKE',
  'PancakeSwap Token',
  'https://pancakeswap.finance/',
)

export const USDC_BSC = new ERC20Token(
  ChainId.BSC,
  '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
  18,
  'USDC',
  'Binance-Peg USD Coin',
  'https://www.centre.io/usdc',
)

export const USDC_TESTNET = new ERC20Token(
  ChainId.BSC_TESTNET,
  '0x64544969ed7EBf5f083679233325356EbE738930',
  18,
  'USDC',
  'Binance-Peg USD Coin',
  'https://www.centre.io/usdc',
)

export const USDC_X1TESTNET = new ERC20Token(
  ChainId.X1_TESTNET,
  '0x04292af1cf8687235a83766d55b307880fc5e76d',
  18,
  'USDC',
  'USD Coin',
  'https://www.centre.io/usdc',
)

export const USDC_XLAYER = new ERC20Token(
  ChainId.X_LAYER,
  '0x74b7f16337b8972027f6196a17a631ac6de26d22',
  6,
  'USDC',
  'USD Coin',
  'https://www.centre.io/usdc',
)

export const USDC_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  6,
  'USDC',
  'USD Coin',
)

export const USDC_GOERLI = new ERC20Token(
  ChainId.GOERLI,
  '0x07865c6E87B9F70255377e024ace6630C1Eaa37F',
  6,
  'tUSDC',
  'test USD Coin',
)

export const USDT_BSC = new ERC20Token(
  ChainId.BSC,
  '0x55d398326f99059fF775485246999027B3197955',
  18,
  'USDT',
  'Tether USD',
  'https://tether.to/',
)

export const USDT_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  6,
  'USDT',
  'Tether USD',
  'https://tether.to/',
)

export const USDT_X1TESTNET = new ERC20Token(
  ChainId.ETHEREUM,
  '0xded3ac2a172a21a729063c39da55c030ec4a8cc9',
  6,
  'USDT',
  'Tether USD',
  'https://tether.to/',
)

export const USDT_XLAYER = new ERC20Token(
  ChainId.X_LAYER,
  '0x1E4a5963aBFD975d8c9021ce480b42188849D41d',
  6,
  'USDT',
  'Tether USD',
  'https://tether.to/',
)

export const BUSD_BSC = new ERC20Token(
  ChainId.BSC,
  '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  18,
  'BUSD',
  'Binance USD',
  'https://www.paxos.com/busd/',
)

export const BUSD_TESTNET = new ERC20Token(
  ChainId.BSC_TESTNET,
  '0xaB1a4d4f1D656d2450692D237fdD6C7f9146e814',
  18,
  'BUSD',
  'Binance USD',
  'https://www.paxos.com/busd/',
)

export const BUSD_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  '0x4Fabb145d64652a948d72533023f6E7A623C7C53',
  18,
  'BUSD',
  'Binance USD',
  'https://www.paxos.com/busd/',
)

export const BUSD_GOERLI = new ERC20Token(
  ChainId.GOERLI,
  '0xb809b9B2dc5e93CB863176Ea2D565425B03c0540',
  18,
  'BUSD',
  'Binance USD',
  'https://www.paxos.com/busd/',
)

export const DAI_X1TESTNET = new ERC20Token(
  ChainId.X1_TESTNET,
  '0x1b981e783d8d139e74ebbd7be5d99d8a0a7eeb0a',
  18,
  'DAI',
  'Dai Stablecoin',
  'https://makerdao.com/',
)

export const DAI_XLAYER = new ERC20Token(
  ChainId.X_LAYER,
  '0xC5015b9d9161Dca7e18e32f6f25C4aD850731Fd4',
  18,
  'DAI',
  'Dai Stablecoin',
  'https://makerdao.com/',
)

export const CAKE_BASE_SEPOLIA = new ERC20Token(
  ChainId.BASE_SEPOLIA,
  '0xe3703935be8e5d83a4b98c742ef5f1c5b040dc93',
  18,
  'CAKE',
  'PancakeSwap Token',
  'https://pancakeswap.finance/',
)

export const BUSD = {
  [ChainId.ETHEREUM]: BUSD_ETH,
  [ChainId.GOERLI]: BUSD_GOERLI,
  [ChainId.BSC]: BUSD_BSC,
  [ChainId.BSC_TESTNET]: BUSD_TESTNET,
}

export const CAKE = {
  [ChainId.BSC]: CAKE_MAINNET,
  [ChainId.BSC_TESTNET]: CAKE_TESTNET,
  [ChainId.X1_TESTNET]: USDT_X1TESTNET,
  [ChainId.BASE_SEPOLIA]: CAKE_BASE_SEPOLIA,
  [ChainId.X_LAYER]: USDT_XLAYER,
}

export const USDC = {
  [ChainId.BSC]: USDC_BSC,
  [ChainId.BSC_TESTNET]: USDC_TESTNET,
  [ChainId.ETHEREUM]: USDC_ETH,
  [ChainId.GOERLI]: USDC_GOERLI,
  [ChainId.X1_TESTNET]: USDC_X1TESTNET,
  [ChainId.X_LAYER]: USDC_XLAYER,
}

export const USDT = {
  [ChainId.BSC]: USDT_BSC,
  [ChainId.ETHEREUM]: USDT_ETH,
  [ChainId.X1_TESTNET]: USDT_X1TESTNET,
  [ChainId.X_LAYER]: USDT_XLAYER,
}

export const WBTC_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  8,
  'WBTC',
  'Wrapped BTC',
)
